/**
 * empresasSimuladasApi — client HTTP para empresas simuladas do Plano Consultoria.
 *
 * Isolamento: as chamadas são autenticadas via Supabase JWT; o backend filtra
 * estritamente por `owner_workspace_id` do usuário. Nunca vaza cross-tenant.
 */
import axios from "axios";
import { getAccessToken } from "@/lib/supabase";
import { impHeaders } from "@/lib/impersonation";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

async function _authHeaders() {
  const token = await getAccessToken();
  if (!token) throw new Error("Sessão expirada");
  return { Authorization: `Bearer ${token}`, ...impHeaders() };
}

async function _req(method, path, { data, params } = {}) {
  const headers = await _authHeaders();
  const r = await axios({
    method,
    url: `${API_BASE}/api/sprints360/empresas-simuladas${path}`,
    headers,
    data,
    params,
    timeout: 15000,
  });
  return r.data;
}

export const empresasSimuladasApi = {
  listar: () => _req("get", ""),
  criar: (payload) => _req("post", "", { data: payload }),
  atualizar: (id, patch) => _req("patch", `/${id}`, { data: patch }),
  excluir: (id) => _req("delete", `/${id}`),
};
